<app-registration-form
  *ngIf="registrationAvailable"
  (formSubmitted)="registration($event)"
  [errorMessage]="errorMessage"
></app-registration-form>
